// Field-path segments for treatment plan template save-validation errors.
// These MUST mirror the backend request DTO field names so that field-level
// errors returned on save (e.g. `weeks[0].groups[1].name`) can be matched to
// the input that produced them.
export const TEMPLATE_FIELD_PATH = {
  name: 'name',
  weeks: 'weeks',
  groups: 'groups'
} as const;
